<template>
  <div>
    <vue-good-table
      ref="datatable"
      mode="remote"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-per-page-change="onPerPageChange"
      @on-search="onSearch"
      :totalRows="totalRecords"
      :search-options="{
        enabled: true,
        placeholder: 'Recherche',
        trigger: 'enter'
      }"
      :sort-options="{
        enabled: true
      }"
      :pagination-options="paginationOptions"
      :rows="rows"
      :columns="columns"
      styleClass="vgt-table bordered striped condensed"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'action'">
          <router-link
            title="Aperçu"
            :to="{
              name: 'devis-show',
              params: { uuid: props.row.devisable_uuid, type: props.row.devisable_type }
            }"
            class="mr-3"
            active-class="current"
            exact-active-class="exact-current"
            ><i class="fa fa-eye text-primary"></i
          ></router-link>
        </span>
        <span v-else-if="props.column.field === 'devisable_type'">
            <a v-if="props.row.devisable_type === 't_devis'"
               title="PDF"
               :href="t_export_pdf + '/' + props.row.devisable_uuid + '/' + locale"
               target="_blank"
               class="mr-3"
            >
            <i class="fas fa-file-pdf text-danger"></i
            ></a>
             <a v-else
                title="PDF"
                :href="o_export_pdf + '/' + props.row.devisable_uuid + '/' + locale"
                target="_blank"
                class="mr-3"
             >
            <i class="fas fa-file-pdf text-danger"></i
            ></a>
          </span>
        <span v-else-if="props.column.field === 'date'">
          {{ convertDate(props.row.date, null, true, false) }}
        </span>
        <span v-else-if="props.column.field === 'validite'">
          {{ convertDate(props.row.validite, null, true, false) }}
        </span>

        <span v-else-if="props.column.field === 'total'">
          <span style="font-weight: bold">
            {{ props.row.total | currency }}
          </span>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
/* eslint-disable */
    import * as services from "../service/services";
    import constant from "@/constant";
    export default {
        name: "Tableau",
        data(){
            return {
                t_export_pdf: constant.URL_FILE + services.T_DEVIS_TO_PDF,
                o_export_pdf: constant.URL_FILE + services.O_DEVIS_TO_PDF,
                isLoading: false,
                columns: [
                    {
                        label: 'Client',
                        field: 'client',
                        width: '100px',
                        sortable: true,

                    },
                    {
                        label: 'Date',
                        field: 'date',
                        width: '100px',
                        sortable: true,

                    },
                    {
                        label: 'Référence',
                        field: 'reference',
                        width: '100px',
                        sortable: true,
                    },
                    {
                        label: 'Réf cotation',
                        field: 'cotation',
                        width: '100px',
                        sortable: true,
                    },
                    {
                        label: 'Validité',
                        field: 'validite',
                        width: '100px',
                        sortable: true,

                    },
                    {
                        label: 'Total',
                        field: 'total',
                        width: '100px',
                        sortable: true,
                        tdClass: 'text-right'
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        html: true,
                        sortable: false,
                        width: '100px',
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    searchTerm: null,
                    sort: {
                        field: 'date',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 100
                },

            };
        },
        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.updateParams({page: 1});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadItems();
            },

            onSearch(params) {
                this.updateParams({searchTerm: params.searchTerm});
                this.loadItems();
            },

            rowsSelected(){
                return this.$refs['datatable'].selectedRows;
            },

            loadItems() {
                let that = this;

                axios.get(services.GET_MY_COTATION_DEVIS, {params: that.serverParams})
                    .then(function (response) {
                        that.totalRecords = response.data.total;
                        that.rows = response.data.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            }
        },
        computed:{
            locale(){
                return this.$store.getters["configapp/locale"];
            },
            paginationOptions() {
                return {
                    enabled: true,
                    mode: 'pages',
                    perPage: this.serverParams.perPage,
                    perPageDropdown: [100, 500, 1000,2000],
                    nextLabel: 'Suivant',
                    prevLabel: 'Précédent',
                    rowsPerPageLabel: 'Elément par page',
                    ofLabel: 'sur',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'Tout'
                }
            }
        },
        mounted(){
            this.loadItems();
        }
    };
</script>

<style scoped>

</style>
